import React, { Fragment } from 'react';
import classNames from 'classnames';
import { shape, object, string, bool, number } from 'prop-types';
import queryString from 'qs';

import Alert from '../../Alert';
import List from '../../SearchBlock/list';
import Spinner from '../../Spinner';
import withSearch from '../../Containers/withSearch';
import Pagination from '../../Pagination';

import FindCareMap from '../../FindCare/findcare-map';
import FindCareSort from '../../FindCare/findcare-sort';
import SearchListItem from '../../FindCare/findcare-search-list-item';
import RedirectToLatLng from './redirect';
import * as utils from '../../FindCare/findcare-map/helpers';

const getHtml = (html) => ({ __html: html });

const SearchList = (props) => {
  const {
    Translations,
    SearchResult,
    findCareState,
    apiConfig,
    EmptySearchResultText,
    location,
  } = props;

  const qs = queryString.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  const searchResult = {
    ...SearchResult,
    ...findCareState[0].searchResultModifiers,
  };

  // Translations is from the scope of this SearchList component.
  // ListProps are sent from the child where the component/function is run.
  const ListItem = (listProps) => (
    <SearchListItem
      {...listProps}
      markerOptions={props.mapConfig.markerOptions()}
      apiKey={apiConfig.googleMapsClientApiKey}
      Translations={Translations}
      hasAltLayout={props.hasAltLayout}
    />
  );

  let heading = searchResult.isLoading ? '...' : searchResult.Heading;
  if (searchResult.HasZeroHits) {
    heading = Translations.zerohits;
  }
  return (
    <div
      className={classNames({
        'is-loading': searchResult.isLoading,
      })}
    >
      {
        // When url is calling for nearby but we have no lat and lng
        // we will try to get geolocastion and redirect user
        // to a search query with lat and lng.
      }
      <RedirectToLatLng qs={qs} location={props.location} />
      <div className="row">
        <div className="large-8 large-centered columns">
          
        {SearchResult.IsSimpleFallbackSearch && (
            <Alert type={'warning'} alert={props}>
              {props.SearchResult.ResultDisclaimer}
            </Alert>
          )}

          {searchResult.Heading && utils.shouldDisplayMap(qs, searchResult) && (
            <div className="c-searchlist__heading__container">
              <h2
                className="c-searchlist__heading"
                dangerouslySetInnerHTML={getHtml(
                  utils.parseSanitizedHeading(heading)
                )}
              ></h2>
            </div>
          )}

          <FindCareMap
            findCareState={findCareState}
            mapConfig={props.mapConfig}
            apiKey={props.apiConfig.googleMapsClientApiKey}
            expand={true}
            SearchResult={searchResult}
            IsPost={props.IsPost}
            Translations={Translations}
          />

          {searchResult.HasZeroHits && (
            <>
              <Alert Modifiers={{ 'findcare-zerohits': true }} type="warning">
                <p
                  className="findcare-zerohits__text"
                  dangerouslySetInnerHTML={getHtml(SearchResult.Heading)}
                />
              </Alert>
              {EmptySearchResultText && (
                <div
                  className="findcare-zerohits__body"
                  dangerouslySetInnerHTML={getHtml(EmptySearchResultText)}
                ></div>
              )}
            </>
          )}

          {!searchResult.HasZeroHits && (
            <Fragment>
              <FindCareSort
                findCareState={props.findCareState}
                SearchResult={searchResult}
                location={props.location}
                IsPost={props.IsPost}
                Translations={props.Translations}
              />

              <List
                {...searchResult}
                query={qs.q}
                CustomSearchListItem={ListItem}
              >
                <Pagination
                  onClick={() =>
                    document.getElementById('search-list-last').focus()
                  }
                  {...searchResult}
                  Spinner={
                    <Spinner Modifiers={{ 'c-spinner--search': true }} />
                  }
                >
                  {searchResult && searchResult.BatchText}
                </Pagination>
              </List>
            </Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

SearchList.propTypes = {
  IsPost: bool,
  Translations: shape({
    zerohits: string,
  }),
  apiConfig: shape({
    googleMapsClientApiKey: string,
  }),
  SearchResult: shape({
    isLoading: bool,
    BatchText: string,
    Heading: string,
    Query: string,
    TotalHits: number,
    HasZeroHits: bool,
  }),
  /** From react-router withRouter() higher order component */
  location: object,
};

export default withSearch(SearchList, null, '/api/hjv/search');
